import script from "./ProVenueEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ProVenueEvents.vue?vue&type=script&setup=true&lang=js"

import "./ProVenueEvents.vue?vue&type=style&index=0&id=579b3a22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-579b3a22"]])

export default __exports__